// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.therapy-page {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.loading {
  text-align: center;
  padding: 2rem;
  color: #7f8c8d;
}

.error-message {
  background-color: #fee;
  color: #c33;
  padding: 0.75rem;
  border-radius: 4px;
  text-align: center;
}

/* Tabs */
.tabs-container {
  display: flex;
  gap: 0.5rem;
  border-bottom: 2px solid #eee;
  margin-bottom: 1rem;
}

.tab-button {
  background: none;
  border: none;
  padding: 0.75rem 1.5rem;
  font-size: 1rem;
  cursor: pointer;
  color: #7f8c8d;
  border-bottom: 3px solid transparent;
  margin-bottom: -2px;
  transition: all 0.2s;
}

.tab-button:hover {
  color: #3498db;
}

.tab-button.active {
  color: #3498db;
  border-bottom-color: #3498db;
  font-weight: 600;
}

/* Session Detail */
.session-detail {
  background: white;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  padding: 1.5rem;
}

.btn-back {
  background: none;
  border: none;
  color: #3498db;
  font-size: 1rem;
  cursor: pointer;
  padding: 0.5rem 0;
  margin-bottom: 1rem;
}

.btn-back:hover {
  text-decoration: underline;
}

.session-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 1rem;
  border-bottom: 2px solid #eee;
  margin-bottom: 1rem;
}

.session-header h3 {
  margin: 0;
  color: #2c3e50;
}

.session-time {
  color: #7f8c8d;
  font-size: 0.875rem;
}

.btn-end-session {
  background-color: #e74c3c;
  color: white;
  border: none;
  padding: 0.5rem 1rem;
  border-radius: 4px;
  cursor: pointer;
  font-size: 0.9rem;
  transition: background-color 0.2s;
}

.btn-end-session:hover {
  background-color: #c0392b;
}

/* Session Summary */
.session-summary {
  background-color: #fff3cd;
  border-left: 4px solid #ffc107;
  padding: 1rem;
  margin-bottom: 1.5rem;
  border-radius: 4px;
}

.session-summary h4 {
  margin: 0 0 0.5rem 0;
  color: #856404;
  font-size: 1rem;
}

.session-summary p {
  margin: 0;
  color: #856404;
  line-height: 1.5;
}

/* Messages */
.messages-list {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.message {
  padding: 1rem;
  border-radius: 8px;
  background-color: #f8f9fa;
}

.message.user {
  background-color: #e3f2fd;
  margin-left: 2rem;
}

.message.assistant {
  background-color: #f1f8e9;
  margin-right: 2rem;
}

.message-header {
  display: flex;
  justify-content: space-between;
  margin-bottom: 0.5rem;
  font-size: 0.875rem;
}

.message-role {
  font-weight: 600;
  color: #2c3e50;
}

.message.user .message-role {
  color: #1976d2;
}

.message.assistant .message-role {
  color: #388e3c;
}

.message-time {
  color: #7f8c8d;
}

.message-content {
  color: #333;
  line-height: 1.5;
  white-space: pre-wrap;
}

.empty-messages {
  text-align: center;
  color: #7f8c8d;
  padding: 2rem;
}

/* Patient Profile */
.patient-profile {
  background: white;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  padding: 1.5rem;
}

.profile-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1.5rem;
  border-bottom: 2px solid #eee;
  padding-bottom: 0.75rem;
}

.patient-profile h3 {
  margin: 0;
  color: #2c3e50;
}

.btn-generate-profile {
  background-color: #27ae60;
  color: white;
  border: none;
  padding: 0.5rem 1rem;
  border-radius: 4px;
  cursor: pointer;
  font-size: 0.9rem;
  transition: background-color 0.2s;
}

.btn-generate-profile:hover:not(:disabled) {
  background-color: #229954;
}

.btn-generate-profile:disabled {
  background-color: #95a5a6;
  cursor: not-allowed;
}

.profile-sections {
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
}

.profile-section {
  background-color: #f8f9fa;
  padding: 1rem;
  border-radius: 6px;
  border-left: 4px solid #3498db;
}

.profile-section h4 {
  margin: 0 0 0.5rem 0;
  color: #2c3e50;
  font-size: 1rem;
  font-weight: 600;
}

.profile-section p {
  margin: 0;
  color: #555;
  line-height: 1.6;
  white-space: pre-wrap;
}

.profile-empty {
  text-align: center;
  padding: 2rem 1rem;
}

.empty-profile {
  color: #7f8c8d;
  font-size: 1.1rem;
  margin-bottom: 1rem;
}

.profile-hint {
  color: #e67e22;
  font-size: 0.95rem;
  line-height: 1.5;
}

/* Session Summaries in Profile */
.profile-sessions {
  margin-top: 2rem;
  padding-top: 1.5rem;
  border-top: 2px solid #eee;
}

.profile-sessions h4 {
  margin: 0 0 1rem 0;
  color: #2c3e50;
  font-size: 1.1rem;
}

.session-summaries-list {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.session-summary-item {
  background-color: #f8f9fa;
  border-radius: 6px;
  padding: 1rem;
  border-left: 4px solid #f39c12;
}

.session-summary-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 0.75rem;
}

.session-date {
  font-weight: 600;
  color: #2c3e50;
  font-size: 0.9rem;
}

.btn-view-session {
  background-color: #3498db;
  color: white;
  border: none;
  padding: 0.25rem 0.75rem;
  border-radius: 4px;
  cursor: pointer;
  font-size: 0.85rem;
  transition: background-color 0.2s;
}

.btn-view-session:hover {
  background-color: #2980b9;
}

.session-summary-text {
  margin: 0;
  color: #555;
  line-height: 1.5;
  white-space: pre-wrap;
}

.profile-meta {
  margin-top: 1.5rem;
  padding-top: 1rem;
  border-top: 1px solid #eee;
  text-align: center;
}

.profile-meta small {
  color: #95a5a6;
}

/* Mobile Responsive */
@media (max-width: 768px) {
  .tabs-container {
    flex-wrap: wrap;
  }

  .tab-button {
    padding: 0.6rem 1rem;
    font-size: 0.9rem;
  }

  .session-detail {
    padding: 1rem;
  }

  .session-header {
    flex-direction: column;
    gap: 0.5rem;
    align-items: flex-start;
  }

  .message {
    padding: 0.75rem;
  }

  .message.user {
    margin-left: 0.5rem;
  }

  .message.assistant {
    margin-right: 0.5rem;
  }

  .patient-profile {
    padding: 1rem;
  }

  .profile-header {
    flex-direction: column;
    gap: 0.75rem;
    align-items: flex-start;
  }

  .profile-section {
    padding: 0.85rem;
  }

  .profile-section h4 {
    font-size: 0.95rem;
  }

  .profile-section p {
    font-size: 0.9rem;
  }

  .session-summary-header {
    flex-direction: column;
    gap: 0.5rem;
    align-items: flex-start;
  }

  .btn-end-session, .btn-generate-profile, .btn-view-session {
    padding: 0.4rem 0.85rem;
    font-size: 0.85rem;
  }
}

@media (max-width: 480px) {
  .tabs-container {
    gap: 0.25rem;
  }

  .tab-button {
    padding: 0.5rem 0.75rem;
    font-size: 0.85rem;
  }

  .session-detail, .patient-profile {
    padding: 0.75rem;
  }

  .session-header h3, .patient-profile h3 {
    font-size: 1rem;
  }

  .session-time {
    font-size: 0.8rem;
  }

  .message {
    padding: 0.6rem;
  }

  .message-header {
    font-size: 0.8rem;
  }

  .message-content {
    font-size: 0.85rem;
    line-height: 1.4;
  }

  .profile-header {
    padding-bottom: 0.5rem;
  }

  .patient-profile h3 {
    font-size: 1rem;
  }

  .profile-section {
    padding: 0.75rem;
  }

  .profile-section h4 {
    font-size: 0.9rem;
  }

  .profile-section p {
    font-size: 0.85rem;
  }

  .session-summary h4 {
    font-size: 0.9rem;
  }

  .session-summary p {
    font-size: 0.85rem;
  }

  .empty-profile {
    font-size: 1rem;
  }

  .profile-hint {
    font-size: 0.85rem;
  }

  .profile-sessions h4 {
    font-size: 1rem;
  }

  .session-summary-text {
    font-size: 0.85rem;
  }

  .session-date {
    font-size: 0.85rem;
  }

  .btn-end-session, .btn-generate-profile, .btn-view-session {
    padding: 0.35rem 0.75rem;
    font-size: 0.8rem;
  }
}

/* Delete Account */
.tab-button-danger {
  color: #e74c3c !important;
}

.tab-button-danger:hover {
  color: #c0392b !important;
}

.tab-button-danger.active {
  color: #c0392b !important;
  border-bottom-color: #e74c3c !important;
}

.delete-account {
  background: white;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  padding: 2rem;
  max-width: 800px;
  margin: 0 auto;
}

.delete-account-header {
  text-align: center;
  margin-bottom: 2rem;
  padding-bottom: 1rem;
  border-bottom: 2px solid #e74c3c;
}

.delete-account-header h3 {
  margin: 0 0 0.5rem 0;
  color: #c0392b;
  font-size: 1.5rem;
}

.warning-text {
  color: #e74c3c;
  font-size: 1.1rem;
  font-weight: 600;
  margin: 0;
}

.delete-account-content {
  display: flex;
  flex-direction: column;
  gap: 2rem;
}

.delete-account-info {
  background-color: #fff5f5;
  border: 2px solid #fed7d7;
  border-radius: 8px;
  padding: 1.5rem;
}

.delete-account-info h4 {
  margin: 0 0 1rem 0;
  color: #c0392b;
  font-size: 1.1rem;
}

.delete-account-info ul {
  list-style: none;
  padding: 0;
  margin: 0 0 1.5rem 0;
}

.delete-account-info li {
  padding: 0.5rem 0;
  color: #555;
  font-size: 1rem;
  border-bottom: 1px solid #fed7d7;
}

.delete-account-info li:last-child {
  border-bottom: none;
}

.delete-account-warning {
  background-color: #fff3cd;
  border-left: 4px solid #ffc107;
  padding: 1rem;
  border-radius: 4px;
}

.delete-account-warning p {
  margin: 0;
  color: #856404;
  line-height: 1.6;
}

.delete-account-warning strong {
  display: block;
  margin-bottom: 0.5rem;
  font-size: 1.05rem;
}

.delete-account-actions {
  text-align: center;
  padding-top: 1rem;
  border-top: 1px solid #eee;
}

.btn-large {
  padding: 1rem 2rem;
  font-size: 1.1rem;
  font-weight: 600;
}

.btn-danger {
  background-color: #e74c3c;
  color: white;
  border: none;
  padding: 0.75rem 1.5rem;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.2s;
}

.btn-danger:hover:not(:disabled) {
  background-color: #c0392b;
  transform: translateY(-1px);
  box-shadow: 0 4px 8px rgba(231, 76, 60, 0.3);
}

.btn-danger:disabled {
  background-color: #95a5a6;
  cursor: not-allowed;
  transform: none;
}

/* Mobile Responsive for Delete Account */
@media (max-width: 768px) {
  .delete-account {
    padding: 1.5rem 1rem;
  }

  .delete-account-header h3 {
    font-size: 1.3rem;
  }

  .warning-text {
    font-size: 1rem;
  }

  .delete-account-info {
    padding: 1rem;
  }

  .delete-account-info h4 {
    font-size: 1rem;
  }

  .delete-account-info li {
    font-size: 0.9rem;
  }

  .btn-large {
    padding: 0.85rem 1.5rem;
    font-size: 1rem;
  }
}

@media (max-width: 480px) {
  .delete-account {
    padding: 1rem 0.75rem;
  }

  .delete-account-header h3 {
    font-size: 1.1rem;
  }

  .warning-text {
    font-size: 0.9rem;
  }

  .delete-account-info {
    padding: 0.85rem;
  }

  .delete-account-info h4 {
    font-size: 0.95rem;
  }

  .delete-account-info li {
    font-size: 0.85rem;
    padding: 0.4rem 0;
  }

  .btn-large {
    padding: 0.75rem 1.25rem;
    font-size: 0.95rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/TherapiePage.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,sBAAsB;EACtB,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA,SAAS;AACT;EACE,aAAa;EACb,WAAW;EACX,6BAA6B;EAC7B,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,uBAAuB;EACvB,eAAe;EACf,eAAe;EACf,cAAc;EACd,oCAAoC;EACpC,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA,mBAAmB;AACnB;EACE,iBAAiB;EACjB,kBAAkB;EAClB,wCAAwC;EACxC,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,eAAe;EACf,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,oBAAoB;EACpB,6BAA6B;EAC7B,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,oBAAoB;EACpB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,oBAAoB;AACpB;EACE,yBAAyB;EACzB,8BAA8B;EAC9B,aAAa;EACb,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,gBAAgB;AAClB;;AAEA,aAAa;AACb;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,aAAa;AACf;;AAEA,oBAAoB;AACpB;EACE,iBAAiB;EACjB,kBAAkB;EAClB,wCAAwC;EACxC,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,qBAAqB;EACrB,6BAA6B;EAC7B,uBAAuB;AACzB;;AAEA;EACE,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,oBAAoB;EACpB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,aAAa;EACb,kBAAkB;EAClB,8BAA8B;AAChC;;AAEA;EACE,oBAAoB;EACpB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,WAAW;EACX,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,iCAAiC;AACjC;EACE,gBAAgB;EAChB,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,wBAAwB;EACxB,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,SAAS;EACT,WAAW;EACX,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA,sBAAsB;AACtB;EACE;IACE,eAAe;EACjB;;EAEA;IACE,oBAAoB;IACpB,iBAAiB;EACnB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,sBAAsB;IACtB,WAAW;IACX,uBAAuB;EACzB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,sBAAsB;IACtB,YAAY;IACZ,uBAAuB;EACzB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,sBAAsB;IACtB,WAAW;IACX,uBAAuB;EACzB;;EAEA;IACE,uBAAuB;IACvB,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,YAAY;EACd;;EAEA;IACE,uBAAuB;IACvB,kBAAkB;EACpB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,wBAAwB;IACxB,iBAAiB;EACnB;AACF;;AAEA,mBAAmB;AACnB;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,uCAAuC;AACzC;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,wCAAwC;EACxC,aAAa;EACb,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,oBAAoB;EACpB,gCAAgC;AAClC;;AAEA;EACE,oBAAoB;EACpB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,eAAe;EACf,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,8BAA8B;EAC9B,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,uBAAuB;EACvB,kBAAkB;EAClB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;EAC3B,4CAA4C;AAC9C;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;AACjB;;AAEA,yCAAyC;AACzC;EACE;IACE,oBAAoB;EACtB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,uBAAuB;IACvB,eAAe;EACjB;AACF;;AAEA;EACE;IACE,qBAAqB;EACvB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,iBAAiB;EACnB;;EAEA;IACE,wBAAwB;IACxB,kBAAkB;EACpB;AACF","sourcesContent":[".therapy-page {\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n}\n\n.loading {\n  text-align: center;\n  padding: 2rem;\n  color: #7f8c8d;\n}\n\n.error-message {\n  background-color: #fee;\n  color: #c33;\n  padding: 0.75rem;\n  border-radius: 4px;\n  text-align: center;\n}\n\n/* Tabs */\n.tabs-container {\n  display: flex;\n  gap: 0.5rem;\n  border-bottom: 2px solid #eee;\n  margin-bottom: 1rem;\n}\n\n.tab-button {\n  background: none;\n  border: none;\n  padding: 0.75rem 1.5rem;\n  font-size: 1rem;\n  cursor: pointer;\n  color: #7f8c8d;\n  border-bottom: 3px solid transparent;\n  margin-bottom: -2px;\n  transition: all 0.2s;\n}\n\n.tab-button:hover {\n  color: #3498db;\n}\n\n.tab-button.active {\n  color: #3498db;\n  border-bottom-color: #3498db;\n  font-weight: 600;\n}\n\n/* Session Detail */\n.session-detail {\n  background: white;\n  border-radius: 8px;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n  padding: 1.5rem;\n}\n\n.btn-back {\n  background: none;\n  border: none;\n  color: #3498db;\n  font-size: 1rem;\n  cursor: pointer;\n  padding: 0.5rem 0;\n  margin-bottom: 1rem;\n}\n\n.btn-back:hover {\n  text-decoration: underline;\n}\n\n.session-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding-bottom: 1rem;\n  border-bottom: 2px solid #eee;\n  margin-bottom: 1rem;\n}\n\n.session-header h3 {\n  margin: 0;\n  color: #2c3e50;\n}\n\n.session-time {\n  color: #7f8c8d;\n  font-size: 0.875rem;\n}\n\n.btn-end-session {\n  background-color: #e74c3c;\n  color: white;\n  border: none;\n  padding: 0.5rem 1rem;\n  border-radius: 4px;\n  cursor: pointer;\n  font-size: 0.9rem;\n  transition: background-color 0.2s;\n}\n\n.btn-end-session:hover {\n  background-color: #c0392b;\n}\n\n/* Session Summary */\n.session-summary {\n  background-color: #fff3cd;\n  border-left: 4px solid #ffc107;\n  padding: 1rem;\n  margin-bottom: 1.5rem;\n  border-radius: 4px;\n}\n\n.session-summary h4 {\n  margin: 0 0 0.5rem 0;\n  color: #856404;\n  font-size: 1rem;\n}\n\n.session-summary p {\n  margin: 0;\n  color: #856404;\n  line-height: 1.5;\n}\n\n/* Messages */\n.messages-list {\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n}\n\n.message {\n  padding: 1rem;\n  border-radius: 8px;\n  background-color: #f8f9fa;\n}\n\n.message.user {\n  background-color: #e3f2fd;\n  margin-left: 2rem;\n}\n\n.message.assistant {\n  background-color: #f1f8e9;\n  margin-right: 2rem;\n}\n\n.message-header {\n  display: flex;\n  justify-content: space-between;\n  margin-bottom: 0.5rem;\n  font-size: 0.875rem;\n}\n\n.message-role {\n  font-weight: 600;\n  color: #2c3e50;\n}\n\n.message.user .message-role {\n  color: #1976d2;\n}\n\n.message.assistant .message-role {\n  color: #388e3c;\n}\n\n.message-time {\n  color: #7f8c8d;\n}\n\n.message-content {\n  color: #333;\n  line-height: 1.5;\n  white-space: pre-wrap;\n}\n\n.empty-messages {\n  text-align: center;\n  color: #7f8c8d;\n  padding: 2rem;\n}\n\n/* Patient Profile */\n.patient-profile {\n  background: white;\n  border-radius: 8px;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n  padding: 1.5rem;\n}\n\n.profile-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 1.5rem;\n  border-bottom: 2px solid #eee;\n  padding-bottom: 0.75rem;\n}\n\n.patient-profile h3 {\n  margin: 0;\n  color: #2c3e50;\n}\n\n.btn-generate-profile {\n  background-color: #27ae60;\n  color: white;\n  border: none;\n  padding: 0.5rem 1rem;\n  border-radius: 4px;\n  cursor: pointer;\n  font-size: 0.9rem;\n  transition: background-color 0.2s;\n}\n\n.btn-generate-profile:hover:not(:disabled) {\n  background-color: #229954;\n}\n\n.btn-generate-profile:disabled {\n  background-color: #95a5a6;\n  cursor: not-allowed;\n}\n\n.profile-sections {\n  display: flex;\n  flex-direction: column;\n  gap: 1.5rem;\n}\n\n.profile-section {\n  background-color: #f8f9fa;\n  padding: 1rem;\n  border-radius: 6px;\n  border-left: 4px solid #3498db;\n}\n\n.profile-section h4 {\n  margin: 0 0 0.5rem 0;\n  color: #2c3e50;\n  font-size: 1rem;\n  font-weight: 600;\n}\n\n.profile-section p {\n  margin: 0;\n  color: #555;\n  line-height: 1.6;\n  white-space: pre-wrap;\n}\n\n.profile-empty {\n  text-align: center;\n  padding: 2rem 1rem;\n}\n\n.empty-profile {\n  color: #7f8c8d;\n  font-size: 1.1rem;\n  margin-bottom: 1rem;\n}\n\n.profile-hint {\n  color: #e67e22;\n  font-size: 0.95rem;\n  line-height: 1.5;\n}\n\n/* Session Summaries in Profile */\n.profile-sessions {\n  margin-top: 2rem;\n  padding-top: 1.5rem;\n  border-top: 2px solid #eee;\n}\n\n.profile-sessions h4 {\n  margin: 0 0 1rem 0;\n  color: #2c3e50;\n  font-size: 1.1rem;\n}\n\n.session-summaries-list {\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n}\n\n.session-summary-item {\n  background-color: #f8f9fa;\n  border-radius: 6px;\n  padding: 1rem;\n  border-left: 4px solid #f39c12;\n}\n\n.session-summary-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 0.75rem;\n}\n\n.session-date {\n  font-weight: 600;\n  color: #2c3e50;\n  font-size: 0.9rem;\n}\n\n.btn-view-session {\n  background-color: #3498db;\n  color: white;\n  border: none;\n  padding: 0.25rem 0.75rem;\n  border-radius: 4px;\n  cursor: pointer;\n  font-size: 0.85rem;\n  transition: background-color 0.2s;\n}\n\n.btn-view-session:hover {\n  background-color: #2980b9;\n}\n\n.session-summary-text {\n  margin: 0;\n  color: #555;\n  line-height: 1.5;\n  white-space: pre-wrap;\n}\n\n.profile-meta {\n  margin-top: 1.5rem;\n  padding-top: 1rem;\n  border-top: 1px solid #eee;\n  text-align: center;\n}\n\n.profile-meta small {\n  color: #95a5a6;\n}\n\n/* Mobile Responsive */\n@media (max-width: 768px) {\n  .tabs-container {\n    flex-wrap: wrap;\n  }\n\n  .tab-button {\n    padding: 0.6rem 1rem;\n    font-size: 0.9rem;\n  }\n\n  .session-detail {\n    padding: 1rem;\n  }\n\n  .session-header {\n    flex-direction: column;\n    gap: 0.5rem;\n    align-items: flex-start;\n  }\n\n  .message {\n    padding: 0.75rem;\n  }\n\n  .message.user {\n    margin-left: 0.5rem;\n  }\n\n  .message.assistant {\n    margin-right: 0.5rem;\n  }\n\n  .patient-profile {\n    padding: 1rem;\n  }\n\n  .profile-header {\n    flex-direction: column;\n    gap: 0.75rem;\n    align-items: flex-start;\n  }\n\n  .profile-section {\n    padding: 0.85rem;\n  }\n\n  .profile-section h4 {\n    font-size: 0.95rem;\n  }\n\n  .profile-section p {\n    font-size: 0.9rem;\n  }\n\n  .session-summary-header {\n    flex-direction: column;\n    gap: 0.5rem;\n    align-items: flex-start;\n  }\n\n  .btn-end-session, .btn-generate-profile, .btn-view-session {\n    padding: 0.4rem 0.85rem;\n    font-size: 0.85rem;\n  }\n}\n\n@media (max-width: 480px) {\n  .tabs-container {\n    gap: 0.25rem;\n  }\n\n  .tab-button {\n    padding: 0.5rem 0.75rem;\n    font-size: 0.85rem;\n  }\n\n  .session-detail, .patient-profile {\n    padding: 0.75rem;\n  }\n\n  .session-header h3, .patient-profile h3 {\n    font-size: 1rem;\n  }\n\n  .session-time {\n    font-size: 0.8rem;\n  }\n\n  .message {\n    padding: 0.6rem;\n  }\n\n  .message-header {\n    font-size: 0.8rem;\n  }\n\n  .message-content {\n    font-size: 0.85rem;\n    line-height: 1.4;\n  }\n\n  .profile-header {\n    padding-bottom: 0.5rem;\n  }\n\n  .patient-profile h3 {\n    font-size: 1rem;\n  }\n\n  .profile-section {\n    padding: 0.75rem;\n  }\n\n  .profile-section h4 {\n    font-size: 0.9rem;\n  }\n\n  .profile-section p {\n    font-size: 0.85rem;\n  }\n\n  .session-summary h4 {\n    font-size: 0.9rem;\n  }\n\n  .session-summary p {\n    font-size: 0.85rem;\n  }\n\n  .empty-profile {\n    font-size: 1rem;\n  }\n\n  .profile-hint {\n    font-size: 0.85rem;\n  }\n\n  .profile-sessions h4 {\n    font-size: 1rem;\n  }\n\n  .session-summary-text {\n    font-size: 0.85rem;\n  }\n\n  .session-date {\n    font-size: 0.85rem;\n  }\n\n  .btn-end-session, .btn-generate-profile, .btn-view-session {\n    padding: 0.35rem 0.75rem;\n    font-size: 0.8rem;\n  }\n}\n\n/* Delete Account */\n.tab-button-danger {\n  color: #e74c3c !important;\n}\n\n.tab-button-danger:hover {\n  color: #c0392b !important;\n}\n\n.tab-button-danger.active {\n  color: #c0392b !important;\n  border-bottom-color: #e74c3c !important;\n}\n\n.delete-account {\n  background: white;\n  border-radius: 8px;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n  padding: 2rem;\n  max-width: 800px;\n  margin: 0 auto;\n}\n\n.delete-account-header {\n  text-align: center;\n  margin-bottom: 2rem;\n  padding-bottom: 1rem;\n  border-bottom: 2px solid #e74c3c;\n}\n\n.delete-account-header h3 {\n  margin: 0 0 0.5rem 0;\n  color: #c0392b;\n  font-size: 1.5rem;\n}\n\n.warning-text {\n  color: #e74c3c;\n  font-size: 1.1rem;\n  font-weight: 600;\n  margin: 0;\n}\n\n.delete-account-content {\n  display: flex;\n  flex-direction: column;\n  gap: 2rem;\n}\n\n.delete-account-info {\n  background-color: #fff5f5;\n  border: 2px solid #fed7d7;\n  border-radius: 8px;\n  padding: 1.5rem;\n}\n\n.delete-account-info h4 {\n  margin: 0 0 1rem 0;\n  color: #c0392b;\n  font-size: 1.1rem;\n}\n\n.delete-account-info ul {\n  list-style: none;\n  padding: 0;\n  margin: 0 0 1.5rem 0;\n}\n\n.delete-account-info li {\n  padding: 0.5rem 0;\n  color: #555;\n  font-size: 1rem;\n  border-bottom: 1px solid #fed7d7;\n}\n\n.delete-account-info li:last-child {\n  border-bottom: none;\n}\n\n.delete-account-warning {\n  background-color: #fff3cd;\n  border-left: 4px solid #ffc107;\n  padding: 1rem;\n  border-radius: 4px;\n}\n\n.delete-account-warning p {\n  margin: 0;\n  color: #856404;\n  line-height: 1.6;\n}\n\n.delete-account-warning strong {\n  display: block;\n  margin-bottom: 0.5rem;\n  font-size: 1.05rem;\n}\n\n.delete-account-actions {\n  text-align: center;\n  padding-top: 1rem;\n  border-top: 1px solid #eee;\n}\n\n.btn-large {\n  padding: 1rem 2rem;\n  font-size: 1.1rem;\n  font-weight: 600;\n}\n\n.btn-danger {\n  background-color: #e74c3c;\n  color: white;\n  border: none;\n  padding: 0.75rem 1.5rem;\n  border-radius: 6px;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.btn-danger:hover:not(:disabled) {\n  background-color: #c0392b;\n  transform: translateY(-1px);\n  box-shadow: 0 4px 8px rgba(231, 76, 60, 0.3);\n}\n\n.btn-danger:disabled {\n  background-color: #95a5a6;\n  cursor: not-allowed;\n  transform: none;\n}\n\n/* Mobile Responsive for Delete Account */\n@media (max-width: 768px) {\n  .delete-account {\n    padding: 1.5rem 1rem;\n  }\n\n  .delete-account-header h3 {\n    font-size: 1.3rem;\n  }\n\n  .warning-text {\n    font-size: 1rem;\n  }\n\n  .delete-account-info {\n    padding: 1rem;\n  }\n\n  .delete-account-info h4 {\n    font-size: 1rem;\n  }\n\n  .delete-account-info li {\n    font-size: 0.9rem;\n  }\n\n  .btn-large {\n    padding: 0.85rem 1.5rem;\n    font-size: 1rem;\n  }\n}\n\n@media (max-width: 480px) {\n  .delete-account {\n    padding: 1rem 0.75rem;\n  }\n\n  .delete-account-header h3 {\n    font-size: 1.1rem;\n  }\n\n  .warning-text {\n    font-size: 0.9rem;\n  }\n\n  .delete-account-info {\n    padding: 0.85rem;\n  }\n\n  .delete-account-info h4 {\n    font-size: 0.95rem;\n  }\n\n  .delete-account-info li {\n    font-size: 0.85rem;\n    padding: 0.4rem 0;\n  }\n\n  .btn-large {\n    padding: 0.75rem 1.25rem;\n    font-size: 0.95rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
